module.exports = __webpack_public_path__ + "media/1784276079991.7cfc39f9.mp4";